import { useCalenderViewStore } from "@stores/useCalenderViewStore";
import moment from "moment";
import React from "react";

const DayCard = (props: any) => {
  const setSelectedDateCalender = useCalenderViewStore((state) => state.setSelectedDateCalender);
  const setIsDrillDownViewSelected = useCalenderViewStore((state) => state.setIsDrillDownViewSelected);
  const setIsProfileView = useCalenderViewStore((state) => state.setIsProfileView);
  const setBalanceOfMonthFlag = useCalenderViewStore((state) => state.setBalanceOfMonthFlag);

  const selectedDate = useCalenderViewStore((state) => state.selectedDateCalender);

  let className;

  if (!props.isMonthDataLoading) {
    className = `day ${props.day.value === "padding" ? "padding" : ""} ${selectedDate.format("DD") === props.day.value ? "currentDay" : ""}`;
  }

  const selectDrillDownFromCalender = (dayDate: any) => {
    setSelectedDateCalender(moment(dayDate));
    setBalanceOfMonthFlag(false);
    setIsDrillDownViewSelected(true);
    setIsProfileView(false);
  };

  const selectDayFromCalender = (dayDate: any) => {
    setSelectedDateCalender(moment(dayDate));
  };

  return !props.isMonthDataLoading ? (
    <div className={className} onDoubleClick={() => props.day.value !== "padding" ? selectDrillDownFromCalender(props.day.date) : null} onClick={() => props.day.value !== "padding" ? selectDayFromCalender(props.day.date) : null}>
      <div className="dayDate">{props.day.value === "padding" ? "" : props.day.value}</div>
      {props.day.value !== "padding" ? (
        <div className="dayBody">
          <div className="dayBody__appointmentCount">
            Appointments<span className="dayBody__separator">{props.day.appointments ? `${props.day.appointments}` : props.day.appointments===0 ? 0 : `NA`}</span>
          </div>
          <div className="dayBody__fields">
            <span className="dayBody__fields__label">New pts</span>
            <span className="dayBody__fields__value">{props.day.new_pts ? `${props.day.new_pts?.toLocaleString()}` : props.day.new_pts===0 ? 0 : `NA`}</span>
          </div>
          <div className="dayBody__fields">
            <span className="dayBody__fields__label">Scheduled</span>
            <span className="dayBody__fields__value">{props.day.scheduled ? `$ ${Math.round(props.day.scheduled)?.toLocaleString()}` : props.day.scheduled ===0 ? `$ 0` : `NA`}</span>
          </div>
          <div className="dayBody__fields">
            <span className="dayBody__fields__label">Budget</span>
            <span className="dayBody__fields__value">{props.day.budget ? `$ ${Math.round(props.day?.budget).toLocaleString()}` : props.day.budget===0 ? `$ 0` : `NA`}</span>
          </div>
          <div className="dayBody__fields">
            <span className="dayBody__fields__label">Production</span>
            <span className="dayBody__fields__value">{props.day.production ? `$ ${Math.round(props.day?.production).toLocaleString()}` :props.day.production===0 ? `$ 0` : `NA`}</span>
          </div>
        </div>
      ) : null}
    </div>
  ) : (
    <div className={"day padding dayPreloader"}>
      <div className="dayDate__preloader shimmerBG"></div>
      <div className="dayBody">
        <div className="dayBody__appointmentCount__preloader shimmerBG"></div>
        <div className="dayBody__fields__preloader shimmerBG"></div>
        <div className="dayBody__fields__preloader shimmerBG"></div>
        <div className="dayBody__fields__preloader shimmerBG"></div>
        <div className="dayBody__fields__preloader shimmerBG"></div>
      </div>
    </div>
  );
};

export default DayCard;
